// import {
//   Box,
//   Grid,
//   Typography,
//   IconButton,
//   Slider,
//   Chip,
//   Paper,
//   Tabs,
//   Tab,
//   Button,
// } from "@mui/material";

// import React, { useEffect, useState, useRef } from "react";
// import PlayArrowIcon from "@mui/icons-material/PlayArrow";
// import PauseIcon from "@mui/icons-material/Pause";
// import VolumeUpIcon from "@mui/icons-material/VolumeUp";
// import { formatTime, getBaseURLFromParams } from "../../../../utils/common";
// import ReactECharts from "echarts-for-react";
// import * as echarts from "echarts";
// import {
//   ResponsiveContainer,
//   ComposedChart,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ReferenceArea,
//   Bar,
// } from "recharts";
// import AudioChart from "./VoiceGraph";
// import SentimentGraph from "../CustomerAnalysis/SentimentGraph";
// import { palette, theme as colorTheme } from "../../../../Convoze.theme";
// import InfoIcon from "@mui/icons-material/Info";

// const primary = colorTheme("palette", "primary").value;
// const primaryBg = colorTheme("palette", "primaryBg").value;
// const positive = colorTheme("palette", "positive").value;
// const positiveBg = colorTheme("palette", "positiveBg").value;
// const negative = colorTheme("palette", "negative").value;
// const negativeBg = colorTheme("palette", "negativeBg").value;
// const neutral = colorTheme("palette", "neutral").value;
// const neutralBg = colorTheme("palette", "neutralBg").value;
// const agent = colorTheme("palette", "agent").value;
// const agentBg = colorTheme("palette", "agentBg").value;

// const VoiceConversation = ({ transcript, customerAnalytics }) => {
//   const [audioSrc, setAudioSrc] = useState(null);
//   const [currentTime, setCurrentTime] = useState(0);
//   const [duration, setDuration] = useState(0);
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [phases, setPhases] = useState([]);
//   const audioRef = useRef(null);
//   const transcriptContainerRef = useRef(null);
//   const activeSentenceRef = useRef(null);
//   const audioPath = process.env.REACT_APP_NIPPON_CONVOZE_AUDIO_PATH;

//   // add new state for tab chnage
//   const [tab, setTab] = useState(0);

// //sentiment graph
// const sentimentGraph =
//   customerAnalytics?.VoiceAndSentimentInsights?.EmotionTrendGraph[0]
//     ?.SentimentGraphData || [];

//   const handleTimeUpdate = () => {
//     if (audioRef.current) {
//       setCurrentTime(audioRef.current.currentTime);
//     }
//   };

//   const handleLoadedMetadata = () => {
//     if (audioRef.current) {
//       setDuration(audioRef.current.duration);
//     }
//   };

//   const togglePlay = () => {
//     if (audioRef.current) {
//       if (isPlaying) {
//         audioRef.current.pause();
//       } else {
//         audioRef.current.play();
//       }
//       setIsPlaying(!isPlaying);
//     }
//   };

//   const handleSeek = (e, value) => {
//     audioRef.current.currentTime = value;
//     setCurrentTime(value);
//   };

//   useEffect(() => {
//     if (transcript?.transcription?.rediarization) {
//       setPhases(transcript.transcription.rediarization);
//     }
//   }, [transcript]);

//   useEffect(() => {
//     if (transcript?.audio?.filePath) {
//       setAudioSrc(`${audioPath}/${transcript.audio.filePath}`);
//     }
//   }, [transcript]);

//   useEffect(() => {
//     if (activeSentenceRef.current && transcriptContainerRef.current) {
//       transcriptContainerRef.current.scrollTo({
//         top:
//           activeSentenceRef.current.offsetTop -
//           transcriptContainerRef.current.offsetTop,
//         behavior: "smooth",
//       });
//     }
//   }, [currentTime]);

//   const getLabel = (e) => {
//     if (e?.role)
//       return e.role === "Customer" ? "C" : e.role === "Agent" ? "A" : "S";
//     return e?.channel === 1 ? "C" : e?.channel === 2 ? "A" : "S";
//   };

//   const TranscriptSection = () => {
//     return (
//       <Box>
//         {/* Custom Audio Player */}
//         <Box sx={{ mt: 0, width: { xs: "90%", md: "100%" } }}>
//           {audioSrc ? (
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 2,
//                 bgcolor: "#f8f9fa",
//                 p: 2,
//                 borderRadius: 2,
//               }}
//             >
//               {/* Circular Play Button */}
//               <IconButton
//                 onClick={togglePlay}
//                 sx={{
//                   bgcolor: primary,
//                   color: "white",
//                   "&:hover": { bgcolor: primaryBg },
//                   width: 30,
//                   height: 30,
//                 }}
//               >
//                 {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
//               </IconButton>

//               {/* Progress Bar */}
//               <Slider
//                 min={0}
//                 max={duration}
//                 value={currentTime}
//                 onChange={handleSeek}
//                 sx={{ flex: 1, color: primary }}
//               />

//               {/* Timestamps */}
//               <Typography variant="caption">
//                 {formatTime(currentTime)}
//               </Typography>
//               <Typography variant="caption">/</Typography>
//               <Typography variant="caption">
//                 {formatTime(duration) || ""}
//               </Typography>

//               {/* <VolumeUpIcon sx={{ ml: 1 }} /> */}
//               {/* Hidden Audio */}

//               {console.log(audioSrc, "ff")}

//               <audio
//                 ref={audioRef}
//                 src={audioSrc}
//                 onTimeUpdate={handleTimeUpdate}
//                 onLoadedMetadata={handleLoadedMetadata}
//                 style={{ display: "none" }}
//               />
//             </Box>
//           ) : (
//             <Typography sx={{ mt: 3, color: "red" }}>
//               Audio not available
//             </Typography>
//           )}
//         </Box>

//         {/* Transcript Section */}
//         <Grid container>
//           <Grid
//             item
//             xs={12}
//             sx={{
//               p: "20px 0",
//               display: "flex",
//               flexDirection: { xs: "column", sm: "row" },

//               justifyContent: "space-between",
//               gap: { xs: 1 },
//             }}
//           >
//             <Typography variant="body2">Transcript</Typography>

//             <Box
//               sx={{
//                 display: "flex",
//                 gap: 2,
//               }}
//             >
//               <Chip
//                 label="Positive"
//                 size="small"
//                 sx={{
//                   backgroundColor: positiveBg,
//                   color: positive,
//                   fontWeight: 500,
//                   px: 1.5,
//                   py: 0.5,
//                   borderRadius: 2,
//                 }}
//               />
//               <Chip
//                 label="Negative"
//                 size="small"
//                 sx={{
//                   backgroundColor: negativeBg,
//                   color: negative,
//                   fontWeight: 500,
//                   px: 1.5,
//                   py: 0.5,
//                   borderRadius: 2,
//                 }}
//               />
//               <Chip
//                 label="Neutral"
//                 size="small"
//                 sx={{
//                   backgroundColor: neutralBg,
//                   color: neutral,

//                   fontWeight: 500,
//                   px: 1.5,
//                   py: 0.5,
//                   borderRadius: 2,
//                 }}
//               />
//             </Box>
//           </Grid>

//           <Grid item md={12} xs={12}>
//             <Grid
//               item
//               xs={12}
//               md={12}
//               sx={{
//                 display: "flex",
//                 justifyContent: "center",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 width: "100%",
//               }}
//             >
//               <Box
//                 sx={{
//                   border: "1px dotted rgb(209, 209, 209)",
//                   borderRadius: 2,
//                   overflow: "hidden",
//                   width: "100%",
//                   p: "10px 0",
//                   bgcolor: "#f9fafb",
//                 }}
//               >
//                 <Box
//                   ref={transcriptContainerRef}
//                   sx={{
//                     height: 280,
//                     overflow: "auto",
//                     width: { xs: "90%", md: "100%" },
//                     p: {
//                       xs: 3,
//                       md: 0,
//                     },
//                     "&::-webkit-scrollbar": { width: "0px" },
//                   }}
//                 >
//                   {phases?.length > 0 ? (
//                     phases?.map((e, i) => {
//                       const isActive =
//                         currentTime >= e?.offset &&
//                         (i === phases.length - 1 ||
//                           currentTime < phases[i + 1]?.offset);
//                       return (
//                         <Box
//                           key={i}
//                           sx={{ mt: 0, mb: 0.5, pt: 2, p: "0 10px" }}
//                           ref={isActive ? activeSentenceRef : null}
//                         >
//                           <Grid
//                             item
//                             xs={12}
//                             md={12}
//                             sx={{
//                               display: "flex",
//                               gap: 2,
//                               alignItems: "flex-start",
//                               bgcolor: "white",
//                               p: 1,
//                               borderRadius: 1,
//                             }}
//                           >
//                             <Typography
//                               variant="caption"
//                               sx={{
//                                 height: 24,
//                                 width: 24,
//                                 borderRadius: "50%",
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                                 // bgcolor:
//                                 //   e.role === "Customer"
//                                 //     ? primaryBg
//                                 //     : e.role === "Agent"
//                                 //       ? agentBg
//                                 //       : "",
//                                 bgcolor:
//                                   e.role === "Customer" ? "#4fbccfff" : primary,
//                                 // color:
//                                 //   e.role === "Customer"
//                                 //     ? primary
//                                 //     : e.role === "Agent"
//                                 //       ? agent
//                                 //       : "",

//                                 color: "white",
//                                 flexShrink: 0,
//                               }}
//                             >
//                               {/* {e?.role == "Customer" ? "C" : "A"} */}
//                               {getLabel(e)}
//                             </Typography>
//                             <Typography
//                               variant="caption"
//                               sx={{
//                                 minWidth: 40,
//                                 color: "text.secondary",
//                                 flexShrink: 0,
//                               }}
//                             >
//                               {e?.time}
//                             </Typography>
//                             <Typography
//                               variant="body2"
//                               sx={{
//                                 color:
//                                   e?.sentiment === "negative"
//                                     ? negative
//                                     : e?.sentiment === "positive"
//                                     ? positive
//                                     : isActive
//                                     ? neutral
//                                     : "",
//                                 borderRadius: 5,
//                               }}
//                             >
//                               {e?.text}
//                             </Typography>
//                           </Grid>
//                         </Box>
//                       );
//                     })
//                   ) : (
//                     <Box
//                       sx={{
//                         width: "100%",
//                         height: "100%",
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                       }}
//                     >
//                       <Chip
//                         label="No transcription data available."
//                         size="small"
//                         sx={{
//                           mt: 2,
//                           backgroundColor: "#E4E5E7",
//                           color: "black",
//                           fontWeight: 500,
//                           px: 1.5,
//                           py: 0.5,
//                           borderRadius: "4px",
//                         }}
//                       />
//                     </Box>
//                   )}
//                 </Box>
//               </Box>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Box>
//     );
//   };

//   const SentimentSection = () => {
//     const primary = colorTheme("palette", "primary").value;
//     const positive = colorTheme("palette", "positive").value;
//     const negative = colorTheme("palette", "negative").value;
//     const neutral = colorTheme("palette", "neutral").value;
//     const positiveBg = colorTheme("palette", "positiveBg").value;
//     const negativeBg = colorTheme("palette", "negativeBg").value;
//     const neutralBg = colorTheme("palette", "neutralBg").value;

//     const sentimentGraph =
//       customerAnalytics?.VoiceAndSentimentInsights?.EmotionTrendGraph?.[0]
//         ?.SentimentGraphData || [];
//     const emotionalPhrases =
//       customerAnalytics?.VoiceAndSentimentInsights?.EmotionalPhrases || [];
//     const toneShifts =
//       customerAnalytics?.VoiceAndSentimentInsights?.ToneShiftsAndSilences || [];

//     const legend = [
//       { label: "Positive", color: positive, bg: positiveBg },
//       { label: "Negative", color: negative, bg: negativeBg },
//       { label: "Neutral", color: neutral, bg: neutralBg },
//     ];

//     return (
// <Box sx={{ width: "100%", mt: 0 }}>
//   <Grid container sx={{ mb: 2 }}>
//     <Grid item xs={12} display="flex" alignItems="center" gap={1}>
//       <Typography variant="body2" mt={2}>
//         Voice & Sentiment Insights
//       </Typography>
//       <Tooltip title="Emotional phrases, shifts and timestamps">
//         <InfoIcon sx={{ fontSize: 18, color: "grey.500" }} />
//       </Tooltip>
//     </Grid>
//   </Grid>

//   {/* <Grid container sx={{ mb: 2 }}>
//     <Grid item xs={12}>
//       <Box display="flex" gap={1.5}>
//         {legend.map(({ label, color, bg }) => (
//           <Chip
//             key={label}
//             label={label}
//             size="small"
//             sx={{
//               backgroundColor: bg,
//               color: color,
//               fontWeight: 500,
//               px: 1.5,
//               py: 0.5,
//               borderRadius: 2,
//             }}
//           />
//         ))}
//       </Box>
//     </Grid>
//   </Grid> */}

//   {/*  GRAPH  */}
//   <Grid container sx={{ mb: 3 }}>
//     <Grid item xs={12}>
//       <Box
//         sx={{
//           border: "1px dotted #d1d1d1",
//           borderRadius: 2,
//           bgcolor: "#f9fafb",
//           p: "10px 0",
//           width: "100%",
//         }}
//       >
//         <Box
//           sx={{
//             height: 280,
//             overflowY: "auto",
//             px: { xs: 3, md: 0 },
//             "&::-webkit-scrollbar": { width: 0 },
//           }}
//         >
//           {sentimentGraph.length ? (
//             <Box sx={{ px: 2, pb: 2 }}>
//               <SentimentGraph sentimentGraph={sentimentGraph} />
//             </Box>
//           ) : (
//             <Chip
//               label="No sentiment data available"
//               size="small"
//               sx={{
//                 backgroundColor: "#E4E5E7",
//                 color: "black",
//                 fontWeight: 500,
//                 px: 1.5,
//                 py: 0.5,
//                 borderRadius: "4px",
//               }}
//             />
//           )}
//         </Box>
//       </Box>
//     </Grid>
//   </Grid>

//         {/*  EMOTIONAL PHRASES  */}
//         <Grid container spacing={3} sx={{ mb: 3 }}>
//           <Grid item xs={12} md={6}>
//             <Typography variant="body2" gutterBottom fontWeight={600}>
//               Key Emotional Phrases
//             </Typography>
//             {emotionalPhrases.length ? (
//               emotionalPhrases.map((p, i) => (
//                 <Box
//                   key={i}
//                   sx={{
//                     mb: 2,
//                     p: 1.5,
//                     borderRadius: 1,
//                     bgcolor: negativeBg,
//                     color: "black",
//                     border: "1px solid #ffebee",
//                   }}
//                 >
//                   <Box display="flex" justifyContent="space-between" mb={0.5}>
//                     <Typography variant="body2" fontWeight={500}>
//                       {p.Phrase || p.phrase}
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       {p.Timestamp || p.timestamp}
//                     </Typography>
//                   </Box>
//                 </Box>
//               ))
//             ) : (
//               <Typography variant="body2" color="text.secondary">
//                 No emotional phrases available.
//               </Typography>
//             )}
//           </Grid>

//           {/*  TONE SHIFTS    */}
//           <Grid item xs={12} md={6}>
//             <Typography variant="body2" gutterBottom fontWeight={600}>
//               Tone Shifts & Silences
//             </Typography>
//             {toneShifts.length ? (
//               toneShifts.map((s, i) => (
//                 <Box
//                   key={i}
//                   sx={{
//                     mb: 2,
//                     p: 1.5,
//                     borderRadius: 1,
//                     bgcolor: "#f9fafb",
//                     border: "1px solid lightgrey",
//                   }}
//                 >
//                   <Box display="flex" justifyContent="space-between" mb={0.5}>
//                     <Typography variant="body2" fontWeight={500}>
//                       {s.Trigger || s.trigger}
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       {s.Timestamp || s.timestamp}
//                     </Typography>
//                   </Box>
//                   <Typography variant="body2" color="text.secondary">
//                     {s.Description || s.description}
//                   </Typography>
//                 </Box>
//               ))
//             ) : (
//               <Typography variant="body2" color="text.secondary">
//                 No tone shifts or silences detected.
//               </Typography>
//             )}
//           </Grid>
//         </Grid>
//       </Box>
//     );
//   };

//   return (
//     <Box sx={{ width: "100%" }}>
//       <Box sx={{ width: "100%" }}>
//         {/* // tabs  */}
//         <Box
//           sx={{
//             display: "inline-flex",
//             gap: 1,
//             p: 0.5,
//             bgcolor: "#f3f4f6",
//             borderRadius: 3,
//           }}
//         >
//           {["Transcript", "Sentiments"].map((label, idx) => (
//             <Button
//               key={label}
//               disableRipple
//               onClick={() => setTab(idx)}
//               sx={{
//                 px: 3,
//                 py: 0.7,
//                 fontSize: 13,
//                 fontWeight: 600,
//                 color: tab === idx ? "#fff" : primary,
//                 bgcolor: tab === idx ? primary : "transparent",
//                 border: tab === idx ? "none" : `1px solid ${primary}`,
//                 borderRadius: 2,
//                 textTransform: "none",
//                 minWidth: "auto",
//                 "&:hover": {
//                   bgcolor: tab === idx ? primary : "rgba(118, 53, 221, 0.08)",
//                 },
//               }}
//             >
//               {label}
//             </Button>
//           ))}
//         </Box>
//         {/* // render section acc to the active tabs */}
//         {tab == 0 && <TranscriptSection />}
//         {tab == 1 && <SentimentSection />}
//       </Box>
//     </Box>
//   );
// };

// export default VoiceConversation;

import {
  Box,
  Grid,
  Typography,
  IconButton,
  Slider,
  Chip,
  Paper,
  Tabs,
  Tab,
  Button,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import { formatTime, getBaseURLFromParams } from "../../../../utils/common";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";
import {
  ResponsiveContainer,
  ComposedChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ReferenceArea,
  Bar,
} from "recharts";
import AudioChart from "./VoiceGraph";
import InfoIcon from "@mui/icons-material/Info";
import SentimentGraph from "../CustomerAnalysis/SentimentGraph";
import { jwtDecode } from "jwt-decode";

const VoiceConversation = ({ transcript, customerAnalytics }) => {
  const [audioSrc, setAudioSrc] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [audioError, setAudioError] = useState(false);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [phases, setPhases] = useState([]);
  const audioRef = useRef(null);
  const transcriptContainerRef = useRef(null);
  const activeSentenceRef = useRef(null);
  const audioPath = process.env.REACT_APP_NIPPON_CONVOZE_AUDIO_PATH;
  const COMPANIES_WITH_SCORING = [
    "mPokket",
    "1Finance",
    "Auric",
    "VTrans",
    "Roposo",
    "vxpressnmc",
    "EBMS Business (India)", "Expert Plus", "Positive Zone", "EBMS Business – RAKEZ Free Zone"
  ];
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : {};
  const showScoringFeatures = COMPANIES_WITH_SCORING.includes(
    decodedToken?.companyName,
  );
  const isMPokket = decodedToken?.companyName === "mPokket";
  const is1finance = decodedToken?.companyName === '1Finance'

  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  //sentiment graph
  const sentimentGraph =
    customerAnalytics?.VoiceAndSentimentInsights?.EmotionTrendGraph || [];

  const handleTimeUpdate = () => {
    if (audioRef.current) {
      setCurrentTime(audioRef.current.currentTime);
    }
  };

  const handleLoadedMetadata = () => {
    if (audioRef.current) {
      setDuration(audioRef.current.duration);
      audioRef.current.playbackRate = playbackSpeed;
    }
  };

  const handleSpeedChange = (speed) => {
    setPlaybackSpeed(speed);
    if (audioRef.current) {
      audioRef.current.playbackRate = speed;
    }
  };

  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play().then(() => setIsPlaying(true)).catch(() => {
          setIsPlaying(false);
          setAudioError(true);
        });
      }
    }
  };

  const handleSeek = (e, value) => {
    audioRef.current.currentTime = value;
    setCurrentTime(value);
  };

  useEffect(() => {
    if (transcript?.transcription?.rediarization) {
      setPhases(transcript.transcription.rediarization);
    }
  }, [transcript]);

  // useEffect(() => {
  //   if (transcript?.audio?.filePath) {
  //     setAudioSrc(`${audioPath}/${transcript.audio.filePath}`);
  //   }
  // }, [transcript]);
  useEffect(() => {
    setAudioError(false);
    // if (is1finance) {
    //   const fileName = transcript?.audio?.fileName;
    //   if (fileName) {
    //     setAudioSrc(`https://uat.convoze.com/${fileName}`);
    //   } else {
    //     setAudioSrc(null);
    //   }
    // }
    if (isMPokket) {
      const fileName = transcript?.audio?.fileName;
      if (fileName) {
        setAudioSrc(`https://acolabz.com/uploads/${fileName}`);
      } else {
        setAudioSrc(null);
      }
    } else {
      const storedPath = transcript?.audio?.filePath
        ? String(transcript.audio.filePath).replace(/\\/g, "/").replace(/^\/+/, "")
        : null;
      if (storedPath && audioPath) {
        const encodedPath = storedPath.split("/").map(encodeURIComponent).join("/");
        setAudioSrc(`${audioPath.replace(/\/$/, "")}/${encodedPath}`);
      } else if (transcript?.audio?._id) {
        const isKiwiCompany = decodedToken?.companyId === "6a6b4ce723abe63bde91abf2";
        const streamPath = isKiwiCompany
          ? "/kiwi/call-recording/stream"
          : "/manager-panel/call-recording/stream";
        setAudioSrc(`${process.env.REACT_APP_NIPPON_CONVOZE_BASE_API_URL}${streamPath}/${transcript.audio._id}?token=${encodeURIComponent(token)}`);
      } else {
        setAudioSrc(null);
      }
    }
  }, [transcript, audioPath, isMPokket, is1finance]);

  useEffect(() => {
    if (activeSentenceRef.current && transcriptContainerRef.current) {
      transcriptContainerRef.current.scrollTo({
        top:
          activeSentenceRef.current.offsetTop -
          transcriptContainerRef.current.offsetTop,
        behavior: "smooth",
      });
    }
  }, [currentTime]);

  const getLabel = (e) => {
    if (e?.role)
      return e.role === "Customer" ? "C" : e.role === "Agent" ? "A" : "S";
    return e?.channel === 1 ? "C" : e?.channel === 2 ? "A" : "S";
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ width: "100%" }}>
        {/* Custom Audio Player */}
        <Box sx={{ width: { xs: "90%", md: "100%" } }}>
          {audioSrc && !audioError ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                bgcolor: "#f8f9fa",
                p: 2,
                borderRadius: 2,
              }}
            >
              {/* Circular Play Button */}
              <IconButton
                onClick={togglePlay}
                sx={{
                  bgcolor: "#7635DD",
                  color: "white",
                  "&:hover": { bgcolor: "#7635DD" },
                  width: 30,
                  height: 30,
                }}
              >
                {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
              </IconButton>

              {/* Progress Bar */}
              <Slider
                min={0}
                max={duration}
                value={currentTime}
                onChange={handleSeek}
                sx={{ flex: 1, color: "#7635DD" }}
              />

              {/* Timestamps */}
              <Typography variant="caption">
                {formatTime(currentTime)}
              </Typography>
              <Typography variant="caption">/</Typography>
              <Typography variant="caption">
                {formatTime(duration) || ""}
              </Typography>

              {/* Speed Controls */}
              <Box sx={{ display: "flex", gap: 0.5, ml: 1 }}>
                {[1, 1.5, 2].map((speed) => (
                  <Button
                    key={speed}
                    onClick={() => handleSpeedChange(speed)}
                    sx={{
                      minWidth: "35px",
                      height: "22px",
                      p: "2px 4px",
                      fontSize: "10px",
                      fontWeight: 700,
                      borderRadius: "4px",
                      bgcolor: playbackSpeed === speed ? "#7635DD" : "transparent",
                      color: playbackSpeed === speed ? "white" : "#7635DD",
                      border: `1px solid #7635DD`,
                      textTransform: "none",
                      "&:hover": {
                        bgcolor: playbackSpeed === speed ? "#5f2bb3" : "rgba(118, 53, 221, 0.08)",
                        border: `1px solid #7635DD`,
                      },
                    }}
                  >
                    {speed}x
                  </Button>
                ))}
              </Box>

              {/* <VolumeUpIcon sx={{ ml: 1 }} /> */}

              {/* Hidden Audio */}
              <audio
                ref={audioRef}
                src={audioSrc}
                onTimeUpdate={handleTimeUpdate}
                onLoadedMetadata={handleLoadedMetadata}
                onError={() => {
                  setIsPlaying(false);
                  setAudioError(true);
                }}
                style={{ display: "none" }}
              />
            </Box>
          ) : (
            <Typography sx={{ mt: 3, color: "#b45309" }}>
              Audio not available on the server. Please download the recording again.
            </Typography>
          )}
        </Box>

        {/* Tabs Header */}
        <Tabs
          value={tabValue}
          onChange={handleChange}
          textColor="primary"
          indicatorColor="primary"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            // mb: 2,
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              color: "#6b6b6b",
              "&.Mui-selected": {
                color: "#7635DD",
              },
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#7635DD",
              height: "3px",
              borderRadius: "2px",
            },
          }}
        >
          <Tab label="Transcript" />
          <Tab label="Sentiment" />
        </Tabs>

        {/* Transcript Section */}
        {tabValue === 0 && (
          <Grid container>
            {/* <Grid
            item
            xs={12}
            sx={{
              p: "20px 0",
            
              gap: { xs: 1 },
            }}
          >
            <AudioChart />
          </Grid> */}
            <Grid
              item
              xs={12}
              sx={{
                p: "20px 0",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },

                justifyContent: "flex-end",
                gap: { xs: 1 },
              }}
            >
              {/* <Typography variant="body2">Transcript</Typography> */}
              <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                {/* Positive */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <Box
                    sx={{
                      width: 12,
                      height: 12,
                      borderRadius: "50%",
                      backgroundColor: "#DCFCE7",
                      border: "2px solid green",
                    }}
                  />
                  <Box sx={{ color: "green", fontWeight: 500, fontSize: 12 }}>
                    Positive
                  </Box>
                </Box>

                {/* Negative */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <Box
                    sx={{
                      width: 12,
                      height: 12,
                      borderRadius: "50%",
                      backgroundColor: "#FFE4E4",
                      border: "2px solid red",
                    }}
                  />
                  <Box sx={{ color: "red", fontWeight: 500, fontSize: 12 }}>
                    Negative
                  </Box>
                </Box>

                {/* Neutral */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <Box
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      backgroundColor: "#FFF1D6",
                      border: "2px solid #FEAB01",
                    }}
                  />
                  <Box sx={{ color: "#FEAB01", fontWeight: 500, fontSize: 12 }}>
                    Neutral
                  </Box>
                </Box>
              </Box>
            </Grid>

            <Grid item md={12} xs={12}>
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    border: "1px dotted rgb(209, 209, 209)",
                    borderRadius: 2,
                    overflow: "hidden",
                    width: "100%",
                    p: "10px 0",
                    bgcolor: "#f9fafb",
                  }}
                >
                  <Box
                    ref={transcriptContainerRef}
                    sx={{
                      height: 280,
                      overflow: "auto",
                      width: { xs: "90%", md: "100%" },
                      p: {
                        xs: 3,
                        md: 0,
                      },
                      "&::-webkit-scrollbar": { width: "0px" },
                    }}
                  >
                    {phases?.length > 0 ? (
                      phases?.map((e, i) => {
                        const isActive =
                          currentTime >= e?.offset &&
                          (i === phases.length - 1 ||
                            currentTime < phases[i + 1]?.offset);
                        return (
                          <Box
                            key={i}
                            sx={{ mt: 0, mb: 0.5, pt: 2, p: "0 10px" }}
                            ref={isActive ? activeSentenceRef : null}
                          >
                            <Grid
                              item
                              xs={12}
                              md={12}
                              sx={{
                                display: "flex",
                                gap: 2,
                                alignItems: "flex-start",
                                bgcolor: "white",
                                p: 1,
                                borderRadius: 1,
                              }}
                            >
                              <Typography
                                variant="caption"
                                sx={{
                                  height: 24,
                                  width: 24,
                                  borderRadius: "50%",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  bgcolor:
                                    e.role === "Customer"
                                      ? "#9b9999ff"
                                      : e.role === "Agent"
                                        ? "#a579ecff"
                                        : "",
                                  color:
                                    e.role === "Customer"
                                      ? "#fff"
                                      : e.role === "Agent"
                                        ? "#fff"
                                        : "",
                                  flexShrink: 0,
                                }}
                              >
                                {/* {e?.role == "Customer" ? "C" : "A"} */}
                                {getLabel(e)}
                              </Typography>
                              <Typography
                                variant="caption"
                                sx={{
                                  minWidth: 40,
                                  color: "text.secondary",
                                  flexShrink: 0,
                                }}
                              >
                                {e?.time}
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  color:
                                    e?.sentiment === "negative"
                                      ? "red"
                                      : e?.sentiment === "positive"
                                        ? "green"
                                        : isActive
                                          ? "blue"
                                          : "grey",
                                  // backgroundColor:
                                  //   e?.sentiment === "positive"
                                  //     ? "#DCFCE7"
                                  //     : e?.sentiment === "negative"
                                  //     ? "#FFE4E4"
                                  //     : "",
                                  // padding:
                                  //   e?.sentiment === "negative" ||
                                  //   e?.sentiment === "positive"
                                  //     ? "5px 10px"
                                  //     : "",
                                  borderRadius: 5,
                                }}
                              >
                                {e?.text}
                              </Typography>
                            </Grid>
                          </Box>
                        );
                      })
                    ) : (
                      <Chip
                        label="No transcription data available."
                        size="small"
                        sx={{
                          mt: 2,
                          backgroundColor: "#E4E5E7",
                          color: "#5F6062",
                          fontWeight: 500,
                          px: 1.5,
                          py: 0.5,
                          borderRadius: "4px",
                        }}
                      />
                    )}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        )}
        {tabValue === 1 && (
          <Box sx={{ width: "100%", mt: 0 }}>
            <Grid container sx={{ mb: 2 }}>
              <Grid item xs={12} display="flex" alignItems="center" gap={1}>
                <Typography variant="body2" mt={2}>
                  Voice & Sentiment Insights
                </Typography>
                <Tooltip title="Emotional phrases, shifts and timestamps">
                  <InfoIcon sx={{ fontSize: 18, color: "grey.500" }} />
                </Tooltip>
              </Grid>
            </Grid>

            {/* <Grid container sx={{ mb: 2 }}>
          <Grid item xs={12}>
            <Box display="flex" gap={1.5}>
              {legend.map(({ label, color, bg }) => (
                <Chip
                  key={label}
                  label={label}
                  size="small"
                  sx={{
                    backgroundColor: bg,
                    color: color,
                    fontWeight: 500,
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 2,
                  }}
                />
              ))}
            </Box>
          </Grid>
        </Grid> */}

            {/*  GRAPH  */}
            <Grid container sx={{ mb: 3 }}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    border: "1px dotted #d1d1d1",
                    borderRadius: 2,
                    bgcolor: "#f9fafb",
                    p: "10px 0",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      height: 280,
                      overflowY: "auto",
                      px: { xs: 3, md: 0 },
                      "&::-webkit-scrollbar": { width: 0 },
                    }}
                  >
                    {sentimentGraph?.length ? (
                      <Box sx={{ px: 2, pb: 2 }}>
                        <SentimentGraph sentimentGraph={sentimentGraph} />
                      </Box>
                    ) : (
                      <Chip
                        label="No sentiment data available"
                        size="small"
                        sx={{
                          backgroundColor: "#E4E5E7",
                          color: "black",
                          fontWeight: 500,
                          px: 1.5,
                          py: 0.5,
                          borderRadius: "4px",
                        }}
                      />
                    )}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default VoiceConversation;


